<h1 mat-dialog-title>
  <T str="Delete"></T>
</h1>

<div mat-dialog-content>
  <p>
    <T str="Are you sure you want to delete this item?"></T>
  </p>
  <p>
    <mat-checkbox [(ngModel)]="archiveCheck">
      <T str="Also archive the connected case?"></T>
    </mat-checkbox>
  </p>
</div>

<div mat-dialog-actions>
  <button
    type="button"
    mat-button
    [mat-dialog-close]="{ del: false, archiveCase: archiveCheck }">
    <T str="No"></T>
  </button>
  <button
    type="button"
    mat-raised-button
    color="warn"
    [mat-dialog-close]="{ del: true, archiveCase: archiveCheck }"
    cdkFocusInitial>
    <T str="Delete"></T>
  </button>
</div>
